import { ENV_VARS } from 'ENV_CONFIG';

export const getFeatures = async () => {
  try {
    const response = await fetch(
      'https://gitlab.com/api/v4/feature_flags/unleash/20956251/client/features',
      {
        headers: {
          'UNLEASH-INSTANCEID': 'SgAmXXcMu5Ect5QGytRG',
          'UNLEASH-APPNAME': ENV_VARS.REACT_APP_FEATURES_APP_ENV,
        },
      },
    );

    if (!response.ok) {
      console.warn(`Features API returned ${response.status}. Using default features.`);
      return [];
    }

    const { features } = await response.json();

    return features || [];
  } catch (error) {
    console.warn(
      'Failed to fetch features from GitLab API. This is expected in local development.',
      error,
    );
    return [];
  }
};
